import React from "react"
import { SearchIcon } from "@heroicons/react/solid"
import Trie from "../AutoComplete/Trie"
import { useSocket } from "../../context/socket-context"
import { useStoryData } from "../../context/story-data"

// useEffect with timeout that sets validationError back to false
const SearchBar = () => {
  const [prefix, setPrefix] = React.useState("")
  const [selectedIndex, setSelectedIndex] = React.useState(-1)
  const [suggestions, setSuggestions] = React.useState([])
  const { publicSites } = useSocket()
  const { setGatheredUID } = useStoryData()
  const submitURL = url => {
    const { uid } = publicSites.find(site => site.url == url)
    setGatheredUID(uid)
  }

  var myTrie = new Trie()

  ;(async () => {
    const words = publicSites.map(site => site.url)
    for (let i = 0; i < words.length; i++) {
      const word = words[i]
      myTrie.insert(word)
    }
  })()

  React.useEffect(() => {
    if (prefix && prefix.length === 0) {
      setSuggestions([])
      setSelectedIndex(-1)
    }

    console.log(selectedIndex)

    // if something from the dropwdown is selected then change the input
    if (selectedIndex > -1 && selectedIndex < suggestions.length) {
      setPrefix(suggestions[selectedIndex])
    }
  }, [prefix, selectedIndex])

  const onChange = e => {
    const value = e.target.value
    setPrefix(value)
    const words = value.split(" ")
    const trie_prefix = words[words.length - 1].toLowerCase()

    const found_words = myTrie.find(trie_prefix).sort((a, b) => {
      return a.length - b.length
    })

    if (
      found_words.length !== 0 &&
      value !== "" &&
      value[value.length - 1] !== " "
    ) {
      const potentialMatches = []
      found_words.forEach(foundWord => {
        if (foundWord != null) {
          var remainder = foundWord.slice(trie_prefix.length)
          potentialMatches.push(value + remainder)
        }
      })
      setSuggestions([...potentialMatches])
    }
    // setUserInput(e.target.value)
  }

  const handleKeyDown = e => {
    // Enter Key Press
    if (e.keyCode === 39) {
      submitURL(prefix)
    }

    // Down Arrow Press
    if (e.keyCode === 40) {
      setSelectedIndex(Math.min(selectedIndex + 1, suggestions.length - 1))
    }

    // Up Arrow Press
    if (e.keyCode === 38) {
      setSelectedIndex(Math.max(selectedIndex - 1, 0))
    }

    // If you use the delete key then unset the selected index
    if (e.keyCode === 8) {
      setSelectedIndex(-1)
      setSuggestions([])
    }
  }

  return (
    <div className="flex flex-col gap-y-4 max-w-2xl mx-auto w-full">
      <div className="w-full bg-white border-4 border-yellow-400 rounded-xl flex justify-between p-1">
        <input
          value={prefix}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          placeholder="your-website.com"
          className="bg-white text-lg md:text-2xl text-gray-900 px-1 md:px-2 focus:outline-none"
        />
      </div>
      <div className="w-full bg-white rounded-lg flex flex-col shadow-lg">
        {suggestions.slice(0,8).map((suggestion, index) => {
          return (
            <button
              key={index}
              type="text"
              name="dropdown-input"
              className={`rounded-lg border-none text-gray-900 flex items-center justify-between ${
                index === selectedIndex ? "bg-gray-200" : "bg-white"
              }`}
              onClick={() => submitURL(suggestion)}
            >
              <p>{suggestion}</p>
              <button
                onClick={() => submitURL(prefix)}
                className="text-gray-900"
              >
                <SearchIcon className="h-4 w-4 md:h-6 md:w-6" />
              </button>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default SearchBar
